import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-new-funnel-template',
  templateUrl: './new-funnel-template.component.html',
  styleUrls: ['./new-funnel-template.component.scss'],
})
export class NewFunnelTemplateComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<NewFunnelTemplateComponent>) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close();
  }
}
